
export const SessionTimeoutErrorCode = "401";

export const enum HttpCode {
    Unauthorized = "401",
    NotFound = "404"
}

export const enum HttpCodeMessage {
    Code401 = "Unauthorised request. Please log in and try again.",
    Code403 = "Forbidden request. Please log in and try again.",
    Code404 = "Resource not found."
}

export const SessionTimeout = "Session timed out";
export const SearchFilterError = "Error searching data.";
export const SaveFilterError = "Error saving data.";

export const Errors = {
    EmailInvalid: "The email provided is invalid. Please correct it and try again.",
    EmailInUse: "Email already in use.",
    EmailMissing: "Please provide a valid email address and try again.",
    Unauthorized: "Incorrect email or password."
}